export default "__VITE_ASSET__UZRs2nwB__"